module.exports = __webpack_public_path__ + "static/media/logo-horizontal-mini-.7941b205.jpg";